export default "__VITE_ASSET__CNOENcz2__"